import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Formik } from 'formik';

export default function Update() {
    const [role, setRole] = useState([]);
    const [users, setUsers] = useState([]);
    const { id } = useParams();
    const navigate = useNavigate();
    const roleRef = useRef();
    const userRef = useRef();

    useEffect(() => {
        GetRole();
        GetUsers();
    });

    useEffect(() => {
        GetRole();
        GetUsers();
    }, [role, users])

    const GetRole = useCallback(() => {
        axios.post('http://localhost:5000/Roles/GetRole', { id: id })
            .then((response) => {
                setRole(response.data[0]);
            })
            .catch((error) => {
               
            })
    }, [role])

    const GetUsers = useCallback(() => {
        axios.get('http://localhost:5000/Users/AllUsers')
            .then((response) => {
                setUsers(response.data);
            })
            .catch((error) => {
                console.log(error);
            })

    }, [users])

    return (
        <React.Fragment>
            <h1>Update Role</h1>

            <main>
                <span>
                    <Link to="/Admin/Roles" className="btn btn-secondary">Back</Link>
                </span>
                <section>
                    <article>
                       <Formik 
                            enableReinitialize={true}
                            initialValues={{ role: role.name, user: role.user ?? "" }}
                            onSubmit={(values, { setSubmitting }) => { 
                                // Formik's values prop won't seem to work in this case.  To save time I will apply the useRef hook to the form.
                               
                               axios.post('http://localhost:5000/Roles/UpdateRole', { roleId: role._id, role: roleRef.current.value, user: userRef.current.value })
                                    .then((response) => { 
                                        console.log(response);
                                    })
                                    .catch((error) => { 
                                        console.log(error);
                                    })
                            }}
                        >
                            {({
                                values, 
                                errors, 
                                touched, 
                                handleChange, 
                                handleBlur, 
                                handleSubmit, 
                                isSubmitting,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="formContainer">
                                        <label htmlFor="roleId">ID:</label>
                                        <input type="text" name="roleId" defaultValue={role._id} disabled />
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="role">Role:</label>
                                        <input type="text" name="role" onChange={handleChange} onBlur={handleBlur} defaultValue={role.name} value={values.role} ref={roleRef}/>
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="user">User:</label>
                                        <select name="user" onChange={handleChange} onBlur={handleBlur} value={values.user} ref={userRef}>
                                            {
                                                [...Array((users.length))].map((e, i) => 
                                                    <option key={i} value={users[i]._id}>{users[i].email}</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                    <button type="submit">Submit</button>
                                </form>
                            )}
                        </Formik>
                    </article>
                </section>
            </main>
        </React.Fragment>
    )
}